var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.DraggableList, {
    attrs: {
      value: _vm.items,
      "item-key": "id",
      "hide-counter": "",
      draggable: !_vm.disabled,
      selected: _vm.selectedId,
    },
    on: {
      input: function ($event) {
        return _setup.emit("reorder", $event)
      },
      "row-click": _setup.onRowClick,
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function ({ element, selected }) {
          return [
            _c(_setup.CrosswordStyleListItem, {
              attrs: {
                item: element,
                disabled: _vm.disabled,
                selected: selected,
              },
              on: {
                edit: function ($event) {
                  return _setup.emit("edit", $event)
                },
                remove: function ($event) {
                  return _setup.emit("remove", $event)
                },
              },
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }